import { useEffect, useRef } from "react";
import { Box, Button } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import { COLORS } from "../theme";
import { useLanguage } from "../i18n/LanguageContext";

export default function SignaturePad({ onChange }) {
  const { t } = useLanguage();
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const empty = useRef(true);

  const pos = (e, canvas) => {
    const rect = canvas.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - rect.left, y: t.clientY - rect.top };
  };

  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const { x, y } = pos(e, canvas);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const { x, y } = pos(e, canvas);
    ctx.lineTo(x, y);
    ctx.strokeStyle = COLORS.ink;
    ctx.lineWidth = 2.4;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.stroke();
    empty.current = false;
  };

  const end = () => {
    drawing.current = false;
    if (!empty.current) onChange(canvasRef.current.toDataURL("image/png"));
  };

  const clear = () => {
    const canvas = canvasRef.current;
    canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
    empty.current = true;
    onChange(null);
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    canvas.width = canvas.clientWidth * ratio;
    canvas.height = canvas.clientHeight * ratio;
    canvas.getContext("2d").scale(ratio, ratio);
  }, []);

  return (
    <Box>
      <Box
        component="canvas"
        ref={canvasRef}
        onMouseDown={start}
        onMouseMove={move}
        onMouseUp={end}
        onMouseLeave={end}
        onTouchStart={start}
        onTouchMove={move}
        onTouchEnd={end}
        sx={{
          width: "100%",
          height: 150,
          border: `1.5px dashed ${COLORS.line}`,
          borderRadius: 1.5,
          bgcolor: "#fff",
          touchAction: "none",
          cursor: "crosshair",
          display: "block",
        }}
      />
      <Button size="small" startIcon={<ReplayIcon fontSize="small" />} onClick={clear} sx={{ mt: 0.5 }}>
        {t("signaturePad.clear")}
      </Button>
    </Box>
  );
}
